// Validating the employee data.

// Validating the employee data for the draft del, requires the list of employees, rather than individual employee data.
export const validateDraftDelEmployees = (employeeDataArray) => {
  const errors = [];
  // If the employeeDataArray is not empty, then we need to validate each employee in the array, just looking to see if the employee is selected. We only need to have an employee id
  employeeDataArray.forEach((employee) => {
    // Creating an employee error object
    const employeeError = {
      employeeRowId: employee.employeeRowId,
      errors: { shifts: [], employeeId: "", employeePosition: "" },
    };
    if (!employee.employeeId || employee.employeeId.trim() === "") {
      employeeError.errors.employeeId = "Employee is required";
    }
    // Validating the shifts for each employee, making sure that the shift start time and end time are valid military times.
    const militaryTimeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    employee.shifts.forEach((shift) => {
      let invalidStartTime = false;
      let invalidEndTime = false;
      if (shift.startTime && !militaryTimeRegex.test(shift.startTime)) {
        invalidStartTime = true;
      }
      if (shift.endTime && !militaryTimeRegex.test(shift.endTime)) {
        invalidEndTime = true;
      }

      if (invalidStartTime || invalidEndTime) {
        employeeError.errors.shifts.push({
          shiftStartTime: invalidStartTime ? "Invalid start time" : "",
          shiftEndTime: invalidEndTime ? "Invalid end time" : "",
          employeeRowId: employee.employeeRowId,
          shiftId: shift.id,
        });
      }
    });
    // If the employeeError object has any errors, then we need to add it to the errors array
    if (
      employeeError.errors.employeeId ||
      employeeError.errors.shifts.length > 0
    ) {
      errors.push(employeeError);
    }
    if (employeeError.errors.shifts.length > 0) {
      errors.push(employeeError);
    }
  });
  return errors;
};

// Validating the employee data for the submitted del, requires the list of employees, rather than individual employee data.
export const validateSubmittedDelEmployees = (employeeDataArray) => {
  const errors = [];
  // If the employeeDataArray is not empty, then we need to validate each employee in the array, just looking to see if the employee is selected. We only need to have an employee id
  employeeDataArray.forEach((employee) => {
    // Creating an employee error object
    const employeeError = {
      employeeRowId: employee.employeeRowId,
      errors: {
        shifts: [],
        employeeId: "",
        employeePosition: "",
        employeeShiftError: "",
      },
    };
    // Checking for the employee id
    if (!employee.employeeId || employee.employeeId.trim() === "") {
      employeeError.errors.employeeId = "Employee is required";
    }
    // Checking for the employee position
    if (!employee.positionId || employee.positionId.length === 0) {
      employeeError.errors.employeePosition = "Employee position is required";
    }
    // Validating the shifts for each employee, making sure that the shift start time and end time are valid military times and that the shifts are actually filled out.
    const militaryTimeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

    // Checking that each employee object has at least 1 shift
    if (employee.shifts.length === 0) {
      employeeError.errors.employeeShiftError = "At least 1 shift is required";
    } else {
      employee.shifts.forEach((shift) => {
        let invalidStartTime = false;
        let invalidEndTime = false;
        if (!shift.startTime || !militaryTimeRegex.test(shift.startTime)) {
          invalidStartTime = true;
        }
        if (!shift.endTime || !militaryTimeRegex.test(shift.endTime)) {
          invalidEndTime = true;
        }

        if (invalidStartTime || invalidEndTime) {
          employeeError.errors.shifts.push({
            shiftStartTime: invalidStartTime ? "Invalid start time" : "",
            shiftEndTime: invalidEndTime ? "Invalid end time" : "",
            employeeRowId: employee.employeeRowId,
            shiftId: shift.id,
          });
        }
      });
    }

    // If the employeeError object has any errors, then we need to add it to the errors array
    if (
      employeeError.errors.employeeId ||
      employeeError.errors.employeeShiftError ||
      employeeError.errors.employeePosition ||
      employeeError.errors.shifts.length > 0
    ) {
      errors.push(employeeError);
    }
    if (employeeError.errors.shifts.length > 0) {
      errors.push(employeeError);
    }
  });
  return errors;
};
